// extracted by mini-css-extract-plugin
module.exports = {"hero__wrapper":"styles_hero__wrapper__32dDK","hero__text":"styles_hero__text__3cmG-"};